import ROUTE_NAMES from '@/vue/routes/routeNames';
import router from '@/vue/router';
import { useUserStore } from '@/vue/stores/user';
import { UserSessionStateC } from '../types/userSession';
import type { UserSessionState } from '../types/userSession';

/**
 * Only a deleted account gets its own screen; other reasons keep the plain login form.
 */
export const leaveUserSession = async (
    { reason, isAccountDeleted }: UserSessionState,
): Promise<void> => {
    useUserStore().reset();

    if (isAccountDeleted && reason !== null) {
        await router.push({ name: ROUTE_NAMES.LOGIN_MAIN, query: { reason } });
        return;
    }

    await router.push({ name: ROUTE_NAMES.LOGIN_MAIN });
};

export const leaveSessionIfAccountDeleted = async (forbiddenAnswer: unknown): Promise<boolean> => {
    if (!UserSessionStateC.is(forbiddenAnswer) || !forbiddenAnswer.isAccountDeleted) {
        return false;
    }

    await leaveUserSession(forbiddenAnswer);

    return true;
};
